import { ExamRequirementTab } from "./options";

interface DefineExamRequirementTabsType {
  isDefaultExamRequirementsTab: boolean;
  isExpiringSoonTab: boolean;
}

export const defineExamRequirementTabs = (
  activeTab: ExamRequirementTab
): DefineExamRequirementTabsType => ({
  isDefaultExamRequirementsTab:
    activeTab === ExamRequirementTab.DEFAULT_EXAM_REQUIREMENTS,
  isExpiringSoonTab: activeTab === ExamRequirementTab.EXPIRING_SOON
});
